interface IReportViewerParameters {
	type: ReportParameterType;
	name: string;
	path: string;
	allowNull: boolean;
	parameterType: ReportParameterSource;
}

enum ReportParameterType {
	None,
	String,
	DateTime,
	Int,
	Float,
	Double,
	Decimal,
	Boolean,
	Guid
}

enum ReportParameterSource {
	Static,
	Dynamic
}

export { IReportViewerParameters, ReportParameterType, ReportParameterSource };
